import React from "react";
import LazyloadImage from "./LazyloadImage";
import { LeadImage } from "./leadImage";

export default class AlbumListingImage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {containerClassName, smartCrop, desktopWidth, desktopHeight, mobileWidth, mobileHeight, is_mobile, isLeadImage} = this.props;
    let mediaEnv = process.env.RAILS_ENV == 'production' ? '' : 'qa-';
    let desktop_width = desktopWidth || 311;
    let desktop_height = desktopHeight || 229;
    let mobile_width = mobileWidth || 302;
    let mobile_height = mobileHeight || 227;

    return (isLeadImage && is_mobile) ?
            <LeadImage
              containerClassName={containerClassName || 'album-main-thumb'}
              width={is_mobile ? mobile_width : desktop_width}
              height={is_mobile ? mobile_height : desktop_height}
              desktopWidth={desktop_width}
              desktopHeight={desktop_height}
              mobileWidth={mobile_width}
              mobileHeight={mobile_height}
              mediaEnv={mediaEnv}
              {...this.props}
            >
            </LeadImage>
            :
            <LazyloadImage containerClassName={containerClassName || 'album-main-thumb'}
              smartCrop={smartCrop || true}
              desktopWidth={desktop_width}
              desktopHeight={desktop_height}
              mobileWidth={mobile_width}
              mobileHeight={mobile_height}
              width={is_mobile ? mobile_width : desktop_width}
              height={is_mobile ? mobile_height : desktop_height}
              lazy={!isLeadImage}
              {...this.props}>
            </LazyloadImage>
  }
}
